import { render, staticRenderFns } from "./ip-restricted.vue?vue&type=template&id=bbebe7c8&"
import script from "./ip-restricted.vue?vue&type=script&lang=js&"
export * from "./ip-restricted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbebe7c8')) {
      api.createRecord('bbebe7c8', component.options)
    } else {
      api.reload('bbebe7c8', component.options)
    }
    module.hot.accept("./ip-restricted.vue?vue&type=template&id=bbebe7c8&", function () {
      api.rerender('bbebe7c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/errors/ip-restricted.vue"
export default component.exports